import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'HighlightCards',
})(({ brandColors, spacing, breakpoints, typography }, props) => ({
  headline: {
    width: '100%',
    paddingBottom: typography.pxToRem(16),
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
    [breakpoints.up('md')]: {
      width: typography.pxToRem(536),
    },
    [breakpoints.up('lg')]: {
      width: typography.pxToRem(600),
    },
  },
  subhead: {
    color: brandColors.tintsNeutral20,
  },
  grid: {
    gap: spacing(3),
    overflow: 'hidden',
    [breakpoints.up('md')]: {
      overflow: 'auto',
    },
  },
  container: {
    background: darkOrLightStyle(props)(
      brandColors.tintsHeroBlue10,
      brandColors.tintsOffWhite60
    ),
  },
  tabs: {
    background: brandColors.white,
  },
}));

export default useStyles;
